import React from "react";
import { useNavigate } from "react-router-dom";
import { DPA_VERSION, DPA_TEXT } from "../dpaText";

export default function DataProcessingAgreement() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", background: "#f0fdf4", padding: "24px 16px" }}>
      <div style={{ background: "white", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.10)", maxWidth: "760px", margin: "0 auto", padding: "36px 32px" }}>
        <button onClick={() => navigate(-1)}
          style={{ background: "none", border: "none", color: "#2563eb", fontSize: "13px", fontWeight: "600", cursor: "pointer", padding: 0, marginBottom: "20px" }}>
          ← Back
        </button>

        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <div style={{ width: "56px", height: "56px", background: "#14532d", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px", fontSize: "24px" }}>⛳</div>
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: "800", color: "#14532d" }}>Data Processing Agreement</h1>
          <p style={{ margin: "6px 0 0", fontSize: "13px", color: "#6b7280" }}>Golf Society Manager — {DPA_VERSION}</p>
        </div>

        <pre style={{ fontSize: "13px", color: "#374151", lineHeight: "1.7", whiteSpace: "pre-wrap", fontFamily: "inherit", margin: 0 }}>{DPA_TEXT}</pre>
      </div>
    </div>
  );
}
